import React from "react"
import { useSelector } from "react-redux"
import { currentUserFullName } from "reduxSlices/sessionSlice"
import ContentBar from "shared/lists/ContentBar"
import withReduxProvider from "shared/withReduxProvider"

const TrackedFormDetails = () => {
  const submitterFullName = useSelector(currentUserFullName)

  return (
    <ContentBar
      title="Submitter"
      description={submitterFullName}
    />
  )
}

export default withReduxProvider(TrackedFormDetails)
